import React from "react";
import PageTitle, { Subtitle } from "components/layout/PageTitle";
import MessageComposer from "components/messages/composer";
import BackButton from "components/shared/BackButton";

export default function NewMessagePage() {
  return (
    <>
      <PageTitle title={I18n.t("js.messages.module_name")} />
      <Subtitle className={"mb-3 mt-8"}>
        {I18n.t("js.messages.new.new_message")}
      </Subtitle>
      <div className="px-3 py-2 border-box mb-10">
        <BackButton href="/messages" />
      </div>
      <MessageComposer />
    </>
  );
}
